// src/components/MagicFixer.js
import React, { useState } from 'react';
import CustomTabs, { CustomTabPanel } from './CustomTabs';
import LasDividerTab from '../../Tabs/LasDividerTab';
import CarRemovalTab from '../../Tabs/CarRemovalTab';
import IntensityTab from '../../Tabs/IntensityTab';
import GapsTab from '../../Tabs/GapsTab';
import EmbankmentReport from '../../Tabs/EmbankmentReport';
import SlopesTab from '../../Tabs/SlopesTab';
import CSFTab from '../../Tabs/CSFTab';
import RoadLaneTab from '../../Tabs/RoadLaneTab';
import HorizontalTab from '../../Tabs/HorizontalTab.jsx';
import RoadDetectionTab from '../../Tabs/RoadDetectionTab.jsx';
import ShouldersWidthCalcTab from '../../Tabs/ShouldersWidthCalcTab.jsx';
import PSDClassificationTab from '../../Tabs/PSDClassificationTab.jsx';
import TemplateCreator from '../../TemplateCreator/TeamplateCreator.jsx';
import AutomaticReports from '../../Tabs/AutomaticReports.jsx';
import ExistentGuardrailsTab from '../../Tabs/ExistentGuardrailsTab.jsx';
import './MagicFixer.css'; // Import the new CSS file
import { useFileContext } from '../../../ContextAPI/FileContext';

const MagicFixer = () => {
  const { filePaths } = useFileContext();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const basePath = '/base/path'; // Set your base path here

  const handleFileSelect = (files) => {
    setSelectedFiles(files);
  };

  return (
    <div className='w100'>
      {/* <SelectorBar onFileSelect={handleFileSelect} basePath={basePath} /> */}
      <div className='content'>
        <CustomTabs defaultActiveKey='tab1'>
          <CustomTabPanel eventKey='tab1' title='Tiling'>
            <LasDividerTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab2' title='CSF'>
            <CSFTab/>
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab3' title='Slopes Calc'>
            <SlopesTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab4' title='Car Removal'>
            <CarRemovalTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab5' title='Road Detection'>
            <RoadDetectionTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab6' title='Road Lane'>
            <RoadLaneTab/>
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab7' title='Shoulders Width Calc'>
            <ShouldersWidthCalcTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab8' title='Existent Guardrails'>
            <ExistentGuardrailsTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab9' title='PSD Classification'>
            <PSDClassificationTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab10' title='Horizontal Curve'>
            <HorizontalTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab11' title='Gaps'>
            <GapsTab />
          </CustomTabPanel>
          <CustomTabPanel eventKey='tab15' title='Automatic Reports'>
            <AutomaticReports />
          </CustomTabPanel>
        </CustomTabs>
      </div>
      {/* <Summery /> */}
    </div>
  );
};

export default MagicFixer;
